package com.oratakashi.web.pages

import androidx.compose.runtime.Composable
import com.oratakashi.web.components.layouts.PageLayout
import com.oratakashi.web.components.widgets.TimelineView
import com.oratakashi.web.resources.ButtonSoftStyle
import com.oratakashi.web.resources.ButtonSolidStyle
import com.oratakashi.web.resources.R
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.components.style.toModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Page("about")
@Composable
fun About() {
    PageLayout("About") {
        Column(
            modifier = it
                .gap(1.cssRem)
        ) {
            SpanText(
                text = R.string.ABOUT_TEXT_ENG,
                modifier = Modifier
                    .fontFamily(R.font.PoppinsRegular.name)
            )

            SpanText(
                text = R.string.ABOUT_TEXT_EDUCATION_ENG,
                modifier = Modifier
                    .fontFamily(R.font.PoppinsMedium.name)
            )

            TimelineView()

            Button(
                modifier = ButtonSoftStyle.toModifier(),
                onClick = {

                }
            ) {
                SpanText(
                    text = R.string.ABOUT_TEXT_CONTACT_ME_ENG,
                    modifier = Modifier
                        .color(R.colors.PRIMARY_500.value)
                )
            }
        }
    }
}